import { Container } from '@mui/material';
import React from 'react';
import { PagesRoutes } from './PagesRoutes';


const PageContainer = ({ children }) => {
  return (
    <Container className="PageContainer-root">
      {/*<Toolbar />*/}
      <PagesRoutes />
      {children}
    </Container>
  );
};

PageContainer.propTypes = {};

export { PageContainer };
